import clsx from "clsx";
import Box from "./Box";

interface Props {
    filter: any,
    getData: any
    children: any
    onReset: () => void
}

const Filters = ({ filter, getData, children, onReset }: Props) => {
    return (
        <div className='m-0'>
            <a
                className={clsx('btn btn-sm btn-flex fw-bold bg-gray-200 btn-color-gray-700 btn-active-color-primary btn-active-light-primary')}
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-static="true"
            >
                <i className='fa fa-sliders fs-6 color-gray-700 me-1' />
                Filtreler
            </a>

            <div className='menu menu-sub menu-sub-dropdown w-500px w-md-500px' data-kt-menu='true'>
                <div className='px-7 py-5'>
                    <Box flexDirection="row">
                        <Box justifyContent="center" flexGrow={1}>
                            <div className='fs-5 text-gray-900 fw-bolder'>Filtreler</div>
                        </Box>
                        <Box justifyContent="center">
                            <i style={{ fontSize: '18px' }} data-kt-menu-dismiss='true' className="actionIcon text-gray-900 fa fa-times" />
                        </Box>
                    </Box>
                </div>

                <div className='separator border-gray-200'></div>

                <div style={{ height: 500, maxHeight: 500, overflowY: 'auto' }} className='px-7 py-5'>
                    {children}
                </div>

                <div className='separator border-gray-200'></div>

                <div className='px-7 py-5'>
                    <div className='d-flex justify-content-end'>
                        <button
                            onClick={onReset}
                            className='btn btn-sm btn-light btn-active-light-primary me-2'
                            data-kt-menu-dismiss='true'
                        >
                            Sıfırla
                        </button>

                        <button
                            onClick={() =>
                                getData({ ...filter, currentPage: 1, skip: 0 })
                            }
                            className='btn btn-sm btn-primary' data-kt-menu-dismiss='true'>
                            Uygula
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

Filters.defaultProps = {
    children: undefined
}

export default Filters;